

import { postRequest } from "../../config/AxiosConfig";
import { getAuthToken } from "../../utils/tokenUtils"
import API_URLS from "../../config/BackendConfig";


// Update Password in Profile Page
export const updatePassword = async ({ current_password, new_password, new_password_confirmation }) => {
  try {
      const payload = {
          update_type: "password",
          old_auth_value: current_password,
          new_auth_value: new_password,
          confirm_auth_value: new_password_confirmation,
      };
      const token = getAuthToken();
      const response = await postRequest({
        url: "https://javabackend.idspay.in/api/v1/admin/authenticate-auth-value",
          headers: {
              'Authorization': `Bearer ${token}`,
          },
          data: payload,
      });
      //console.log("ResPass",response)
      return response;
  } catch (error) {
      console.error('Error updating password:', error.response?.data || error.message);
      throw error;
  }
};

// Update PIN in Profile Page
export const updatePin = async ({ current_pin, new_pin, new_pin_confirmation }) => {
  try {
      const payload = {
          update_type: "pin",
          old_auth_value: current_pin,
          new_auth_value: new_pin,
          confirm_auth_value: new_pin_confirmation,
      };
      const token = getAuthToken();
      const response = await postRequest({
          url: "https://javabackend.idspay.in/api/v1/admin/authenticate-auth-value",
          headers: {
              'Authorization': `Bearer ${token}`,
          },
          data: payload,
      });
     // console.log("resspin",response)
      return response;
  } catch (error) {
      console.error('Error updating PIN:', error.response?.data || error.message);
      throw error;
  }
};



// Verify OTP For Auth Value Update
export const verifyUpdateAuthValueOtp = async ({ identifier, otp }) => {
  try {
    const token = getAuthToken();

    const response = await postRequest({
      url: "https://javabackend.idspay.in/api/v1/admin/update-auth-value",
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      data: {
        identifier,
        otp
      }
    });
     console.log("response Update",response);
    return response;
  } catch (error) {
    console.error('Error verifying OTP:', error.response?.data || error.message);
    throw error;
  }
};
